import { Component } from '@angular/core';
import { VitaminDSupplementComponent } from '@consultation-upsells/vitamin-d-supplement/vitamin-d-supplement.component';

@Component({
  selector: 'app-vitamin-d-supplement-rash',
  imports: [VitaminDSupplementComponent],
  templateUrl: './vitamin-d-supplement-rash.component.html',
})
export class VitaminDSupplementRashComponent {}
